var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagUae(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.142883,
    width: 18,
    height: 13.7143,
    fill: "url(#pattern0_7087_348)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_7087_348",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_7087_348",
    transform: "matrix(0.00586081 0 0 0.00769231 -0.261905 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_7087_348",
    width: 260,
    height: 130,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQQAAACCCAIAAAAv9CEsAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAABBKADAAQAAAABAAAAggAAAAAUmA3RAAAD/klEQVR4Ae3XMW6TURRE4d/EjanZAAugZF2skQakKBJboKSgBRojI7GE+EozvvrS+7155/goyel2PPzPx08fXs5vHv4ZHpAm4DuUNuD+GgJiqFFhSJqAGNIG3F9DQAw1KgxJExBD2oD7awiIoUaFIWkCYkgbcH8NATHUqDAkTUAMaQPuryEghhoVhqQJiCFtwP01BMRQo8KQNAExpA24v4aAGGpUGJImIIa0AffXEBBDjQpD0gTEkDbg/hoCYqhRYUiagBjSBtxfQ0AMNSoMSRMQQ9qA+2sIiKFGhSFpAmJIG3B/DQEx1KgwJE1ADGkD7q8hIIYaFYakCYghbcD9NQTEUKPCkDQBMaQNuL+GgBhqVBiSJiCGtAH31xAQQ40KQ9IExJA24P4aAmKoUWFImoAY0gbcX0NADDUqDEkTEEPagPtrCIihRoUhaQJiSBtwfw0BMdSoMCRNQAxpA+6vIXCuWfL6IT///Diebq//vE8i8J/AacGX6Pnb5+vlQigCdxLYEMPx6/fxVgx3fhN8/FjxP8PfK5MI3E9gRQz3Y3ACAseO3wxEIjBBwG+GCYrOWEFADCs0esQEATFMUHTGCgJiWKHRIyYIiGGCojNWEBDDCo0eMUFADBMUnbGCgBhWaPSICQJimKDojBUExLBCo0dMEBDDBEVnrCAghhUaPWKCgBgmKDpjBQExrNDoERMExDBB0RkrCIhhhUaPmCAghgmKzlhBQAwrNHrEBAExTFB0xgoCYlih0SMmCIhhgqIzVhAQwwqNHjFBQAwTFJ2xgoAYVmj0iAkCYpig6IwVBMSwQqNHTBAQwwRFZ6wgIIYVGj1igoAYJig6YwUBMazQ6BETBMQwQdEZKwiIYYVGj5ggIIYJis5YQUAMKzR6xAQBMUxQdMYKAmJYodEjJgiIYYKiM1YQWBHD03mFC48IE9jwNXr++uV6uYRBuv7xCZxuj/+G98fx/fFf4QVxAhv+THoXp2jACgIbYlghwiPyBMSQd2BBCQExlIgwI09ADHkHFpQQEEOJCDPyBMSQd2BBCQExlIgwI09ADHkHFpQQEEOJCDPyBMSQd2BBCQExlIgwI09ADHkHFpQQEEOJCDPyBMSQd2BBCQExlIgwI09ADHkHFpQQEEOJCDPyBMSQd2BBCQExlIgwI09ADHkHFpQQEEOJCDPyBMSQd2BBCQExlIgwI09ADHkHFpQQEEOJCDPyBMSQd2BBCQExlIgwI09ADHkHFpQQEEOJCDPyBMSQd2BBCQExlIgwI09ADHkHFpQQEEOJCDPyBMSQd2BBCQExlIgwI09ADHkHFpQQEEOJCDPyBMSQd2BBCQExlIgwI09ADHkHFpQQEEOJCDPyBP4BxOkWUVTpLxIAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagUae);
export default __webpack_public_path__ + "static/media/flag-uae.b253a78907a8792d7a078b21c76c5d7b.svg";
export { ForwardRef as ReactComponent };